/**
 * @generated SignedSource<<faa784113aaf6c37519efc0faa0b9f46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilityFiltersModal_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleSwitcher_session">;
  readonly " $fragmentType": "DepartmentAvailabilityFiltersModal_session";
};
export type DepartmentAvailabilityFiltersModal_session$key = {
  readonly " $data"?: DepartmentAvailabilityFiltersModal_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityFiltersModal_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartmentAvailabilityFiltersModal_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleSwitcher_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "808413f51037606f875d44253c4763fb";

export default node;
